export const CellType = {
  immovable: 101,
  blank: 100,
  delivery: 102,
}